// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/46de88bdccefb79ec69b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"127da2b1d244ac6d396a","267":"5b9684610dc4ff39dbd7","268":"cf1b25ad1afb1d0e0492"}[chunkId] + ".chunk.js";
};